import React, { FC, useState, useEffect } from 'react'
import { useIntl } from 'react-intl'
import { IndicatorCard } from '@/components/cards/IndicatorCard'
import {
  Indicators,
  initialIndicators
} from '@/app/modules/p2c/reports/customer/core/_models'
import { getIndicators } from '@/app/modules/p2c/reports/customer/core/_requests'

type Props = {
  from: Date
  to: Date
  timezone: string
}
const IndicatorsGroup: FC<Props> = ({ from, to, timezone }) => {
  const intl = useIntl()
  const [indicators, setIndicators] = useState<Indicators>(initialIndicators)
  const [isLoading, setIsLoading] = useState<boolean>(false)

  useEffect(() => {
    const load = async () => {
      try {
        setIsLoading(true)
        setIndicators(await getIndicators({ from, to, timezone }))
      } catch (e: unknown) {
        console.log(e)
      } finally {
        setIsLoading(false)
      }
    }
    load()
  }, [from, to])
  return (
    <div className="row">
      <div className="col-xl-2 mb-5 mb-xl-10">
        <IndicatorCard
          icon="profile-user"
          color="warning"
          title="Customers"
          value={indicators.users}
          isLoading={isLoading}
        />
      </div>

      <div className="col-xl-2 mb-5 mb-xl-10">
        <IndicatorCard
          icon="euro"
          color="danger"
          title="AVG paid"
          value={intl.formatNumber(indicators.avgPaid, {
            style: 'currency',
            currency: 'EUR'
          })}
          isLoading={isLoading}
        />
      </div>

      <div className="col-xl-2 mb-5 mb-xl-10">
        <IndicatorCard
          icon="abstract-45"
          color="primary"
          title="AVG transaction"
          value={intl.formatNumber(indicators.avgTrx, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          })}
        />
      </div>

      <div className="col-xl-2 mb-5 mb-xl-10">
        <IndicatorCard
          icon="handcart"
          color="info"
          title="AVG order"
          value={intl.formatNumber(indicators.avgOrder, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          })}
        />
      </div>


      <div className="col-xl-2 mb-5 mb-xl-10">
        <IndicatorCard
          icon="chart-pie-simple"
          color="success"
          title="AVG earnings"
          value={intl.formatNumber(indicators.avgTrx, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          })}
        />
      </div>
    </div>
  )
}

export default IndicatorsGroup
